import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import Content from './content';

const FixedNavigation = styled.div`
	position: fixed;
	width: 100%;
	top: 0px;
	z-index: 1;
	background: ${props => props.theme.colors.auxiliary};

	@media ${props => props.theme.device.lgDesktop} {
		width: 1160px;
	}

	@media ${props => props.theme.device.mobile} {
		top: 52px;
	}
`;

const NavigationWrapper = styled.div`
	background: ${props => props.theme.colors.auxiliary};
`;

const Navigation = (): JSX.Element => {
	const navRef = useRef(null);
	const [isFixed, setIsFixed] = useState(false);

	const handleOnScroll = () => {
		const navElement = navRef.current;

		setIsFixed(window.pageYOffset >= navElement.offsetTop);
	};

	useEffect(() => {
		document.addEventListener('scroll', handleOnScroll);

		return () => {
			document.removeEventListener('scroll', handleOnScroll);
		};
	}, []);

	return (
		<>
			{isFixed && (
				<FixedNavigation>
					<Content isFixed />
				</FixedNavigation>
			)}
			<NavigationWrapper ref={navRef} isFixed={isFixed}>
				<Content isFixed={isFixed} />
			</NavigationWrapper>
		</>
	);
};

export default Navigation;
